/**
 * Public apply hub (`/apply`): which venues appear as cards.
 * Authenticated admins still pass RLS and receive archived rows from PostgREST;
 * we filter here so the home grid matches the anonymous experience.
 *
 * @see docs/APP_UI_SPEC.md — F1
 * @param {Array<object>|null|undefined} venues
 * @returns {Array<object>}
 */
export function venuesVisibleOnPublicHome(venues) {
  return (venues || []).filter((v) => v && !v.archived_at);
}
